import service from "./service";
import packageInfo from "../../../package.json";

const SESSION_KEY = "smpl-catalog-diagnostic-session";
const ACTIVE_KEY = "smpl-catalog-active-session";

const sessionId = () => {
  let value = sessionStorage.getItem(SESSION_KEY);
  if (!value) {
    value = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
    sessionStorage.setItem(SESSION_KEY, value);
  }
  return value;
};

const safeDetails = details => {
  if (!details || typeof details !== "object") return {};
  const allowed = ["message", "request", "online", "imageCount", "thumbnailCount", "fullImageCount", "reason"];
  return allowed.reduce((result, key) => {
    if (details[key] !== undefined) result[key] = details[key];
    return result;
  }, {});
};

const record = (eventType, context = {}) => {
  const payload = {
    sessionId: sessionId(),
    eventType,
    severity: context.severity || "info",
    route: window.location.pathname,
    CustomerId: context.CustomerId || null,
    categoryId: context.categoryId || null,
    categoryName: context.categoryName || null,
    productCount: context.productCount,
    durationMs: context.durationMs,
    statusCode: context.statusCode,
    appVersion: packageInfo.version,
    device: navigator.userAgent,
    details: safeDetails(context.details),
  };
  // Diagnostics must never interfere with order entry.
  return service.record(payload).catch(() => null);
};

const markCatalogActive = context => {
  try {
    localStorage.setItem(ACTIVE_KEY, JSON.stringify({
      sessionId: sessionId(),
      CustomerId: context.CustomerId || null,
      categoryId: context.categoryId || null,
      categoryName: context.categoryName || null,
      at: new Date().toISOString(),
    }));
  } catch (error) {
    record("storage_failed", { ...context, severity: "error", details: { message: error.message } });
  }
};

const clearCatalogActive = () => {
  try { localStorage.removeItem(ACTIVE_KEY); } catch (error) { /* best effort */ }
};

const activeContext = () => {
  try { return JSON.parse(localStorage.getItem(ACTIVE_KEY)) || {}; }
  catch (error) { return {}; }
};

const reportInterruptedCatalog = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(ACTIVE_KEY));
    if (!saved) return;
    record("unexpected_reload", {
      ...saved,
      severity: "warning",
      details: { reason: "catalog was active when the application restarted" },
    });
    localStorage.removeItem(ACTIVE_KEY);
  } catch (error) { /* corrupt markers are non-critical */ }
};

export default { sessionId, record, markCatalogActive, clearCatalogActive, activeContext, reportInterruptedCatalog };
